import { Button, Container, Grid, Stack } from "@mui/material";
import React from "react";
import { useDialogContext } from "../../contexts";
import { VdsPageTitle, VdsTextField } from "../../@vds";

export const ContactsPage = () => {

    const openDialog = useDialogContext();

    const handleInfoRequest = React.useCallback(() => {

        openDialog({
            title: "Richiesta avvenuta con successo",
            content: "A breve verrai ricontattato all'indirizzo e-mail specificato"
        });
    }, [openDialog]);

    return (
        <Container maxWidth="md" sx={{ height: 'calc(100vh - 100px)', overflow: 'auto' }} >
            <Grid container spacing={2}>
                <Grid lg={12} item>
                    <VdsPageTitle
                        title="Compila il form per richiedere informazioni"
                        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    />
                </Grid>
                <Grid sm={12} lg={6} item>
                    <VdsTextField label="Nome*" defaultValue="" />
                </Grid>
                <Grid sm={12} lg={6} item>
                    <VdsTextField label="Cogome*" defaultValue="" />
                </Grid>
                <Grid sm={12} lg={6} item>
                    <VdsTextField label="Email*" defaultValue="" />
                </Grid>
                <Grid sm={12} lg={6} item>
                    <VdsTextField label="Partita IVA*" defaultValue="" />
                </Grid>
                <Grid sm={12} lg={12} item>
                    <VdsTextField label="Ragione sociale*" defaultValue="" />
                </Grid>
                <Grid sm={12} lg={12} item>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                        <Button color="primary" variant="contained" onClick={handleInfoRequest}>
                            Richiedi informazioni
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Container>
    );
};
